// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","buttonContainer":"_1CsyhDTnNQmh6MW7xdLfGT","flashMessage":"bcWHBLYUCiegWSrqHczil"};